import React, { useEffect, useState, useCallback } from "react";
import { Modal, Form, Row, Col, message, Spin ,Tag} from "antd";
import WarehouseService from "src/services/WarehouseService";
import { SectionCard, SectionTitle } from "../../Modal/styleds";
import TableCustom from "src/components/Table/CustomTable";
import dayjs from "dayjs";

const simColumns = [
  {
    title: "Seri SIM",
    dataIndex: "serial_number",
    key: "serial_number",
    align: 'center',
  },
  {
    title: "Số điện thoại",
    dataIndex: "phone_number",
    key: "phone_number",
    align: 'center',
    render: (text) => text || "Chưa có",
  },
];
const ViewDetailModal = ({ open, onCancel, recordId }) => {
   const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});

  const approvedby = detail.approvedby || {};

  const fetchPackageDetail = useCallback(async () => {
    if (!recordId) return;
    setLoading(true);
    try {
      const response = await WarehouseService.getDetailExportWarehouse(recordId);
      if (response?.success) {
        setDetail(response.success);
      } else {
        message.error("Không thể lấy thông tin chi tiết.");
      }
    } catch (error) {
      console.error("Lỗi khi lấy chi tiết:", error);
      message.error("Đã xảy ra lỗi khi lấy chi tiết.");
    } finally {
      setLoading(false);
    }
  }, [recordId]);

  useEffect(() => {
    if (open) {
      fetchPackageDetail();
    }
  }, [open, fetchPackageDetail]);

  return (
    <Modal
      open={open}
      title="Chi tiết phiếu xuất kho"
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Spin spinning={loading}>
        {detail && (
          <Form layout="vertical">
            <SectionCard>
              <SectionTitle>Thông tin chung</SectionTitle>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Mã phiếu xuất">
                    <span>{detail?.wsm_export_id}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Gói cước">
                    <span>{detail?.package?.name}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Khách hàng">
                    <span>{detail?.customer?.fullname}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Đơn giá SIM (VNĐ)">
                    <span>{Number(detail?.sim_unit_price).toLocaleString()}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Số lượng SIM">
                    <span>{detail?.sim_quantity}</span>
                  </Form.Item>
                </Col>
              
                <Col span={12}>
                  <Form.Item label="Loại SIM">
                    <span>{detail?.sim_type}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Loại hình SIM">
                    <span>{detail?.type_sim}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Nhà cung cấp">
                    <span>{detail?.supplier?.name}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Nhà mạng">
                    <span>{detail?.network?.name}</span>
                  </Form.Item>
                </Col>
                </Row>
                <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Loại chiết khấu">
                  <span>
                      {{
                        percent: "Chiết khấu %",
                        fixed: "Chiết khấu giá tiền",
                      }[detail?.export?.discount_type] || "Không xác định"}
                    </span>

                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Chiết khấu">
                    <span>{Number(detail?.export?.discount).toLocaleString()}</span>
                  </Form.Item>
                </Col>
                </Row>
                <Row gutter={16}>
                <Col span={12}>
                <Form.Item label="Trạng thái">
                  {{
                    "0": <Tag color="blue">Chờ duyệt</Tag>,
                    "1": <Tag color="green">Đã duyệt</Tag>,
                    "2": <Tag color="red">Từ chối</Tag>,
                  }[detail?.status] || <Tag color="default">Không xác định</Tag>}
                </Form.Item>
              </Col>
                
                {detail?.status === "2" && (
                  <Col span={12}>
                    <Form.Item label="Lý do từ chối">
                      <span>{detail?.note}</span>
                    </Form.Item>
                  </Col>
                )}
               
              </Row>
            </SectionCard>

            <SectionCard>
              <SectionTitle>Thông tin phê duyệt</SectionTitle>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Người duyệt">
                    <span>{detail?.approvedby?.fullname}</span>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Thời gian duyệt">
                  <span>{detail?.approved_at ? dayjs(detail.approved_at).format("DD/MM/YYYY") : ""}</span>
                  </Form.Item>
                </Col>
              </Row>
            </SectionCard>

            <SectionCard>
              <SectionTitle>Thông tin SIM</SectionTitle>
              <TableCustom
                isPrimary
                dataSource={detail.sims || []}
                columns={simColumns}
                rowKey={(record, index) => record.ID || index}
                pagination={false}
                bordered
                scroll={{ x: "max-content" }} />
            </SectionCard>

          </Form>
        )}
      </Spin>
    </Modal>
  );
};

export default ViewDetailModal;
